import { client } from './client';
import type {
  ApiResponse,
  AssignmentListItem,
  AssignmentListResponse,
} from '@/types/api';

// GET /api/v1/assignments returns { data: { assignments: [...], total: N } }.
// The backend does NOT support a `?status=` filter — callers filter client-side.
export async function listAssignments(): Promise<AssignmentListItem[]> {
  const { data } = await client.get<ApiResponse<AssignmentListResponse>>(
    '/api/v1/assignments',
  );
  return data.data?.assignments ?? [];
}

export async function completeAssignment(id: string): Promise<AssignmentListItem> {
  const { data } = await client.put<ApiResponse<AssignmentListItem>>(
    `/api/v1/assignments/${id}/complete`,
  );
  return data.data;
}
